export const compactPhoneNumber = value => {
  const phoneNumber = String(value || '').trim();
  if (!phoneNumber) return '';

  const digits = phoneNumber.replace(/\D/g, '');
  if (!digits) return '';

  return phoneNumber.startsWith('+') ? `+${digits}` : digits;
};

export const compactWhatsappUsername = value => {
  const username = String(value || '')
    .trim()
    .replace(/^@+/, '');
  return username ? `@${username}` : '';
};

export const conversationIdentifierWithContact = (
  conversationId,
  phoneValue,
  whatsappUsernameValue
) => {
  const identity =
    compactPhoneNumber(phoneValue) ||
    compactWhatsappUsername(whatsappUsernameValue);
  return `#${conversationId}${identity ? ` - ${identity}` : ''}`;
};
